<template>
  <span>
   <span type="border" class="how-dream-looks-like cursor-pointer text-sm" @click="open" color="dark">How should a Dream look like?</span>


  <vs-popup class="how-to-create-dream-popup" title="" :active.sync="popupActive">
    <h2 class="mb-2"><span class="font-bold">How to pick your dream</span></h2>
    <h4 class="mb-2">On which life category will be your dream focusing on?</h4>
    <DreamCategories/>

    <div class="mt-10">
      <h4 class="mb-2">Your long-term objectives should meet the following criteria</h4>
      <LongTermGoalCriteria/>
    </div>

  </vs-popup>
  </span>
 </template>


<script>
import LongTermGoalCriteria from './LongTermGoalCriteria'
import DreamCategories from './DreamCategories'
import trackAnalytics from '@/helpers/trackAnalytics'

export default {
  components: {
    DreamCategories,
    LongTermGoalCriteria,
  },
  data () {
    return {
      popupActive: false
    }
  },
  methods: {
    open () {
      trackAnalytics(this, 'app_action', 'click', 'how-dream-looks-like', this.$store.getters.daysFromRegistration)
      this.popupActive = true
    }
  }
}
</script>


<style scoped>
h2 {
  font-size: 2.5rem;
}

.how-dream-looks-like {
  cursor: pointer;
  margin-top: 2rem;
}

</style>
